import React from 'react';
import { NavLink } from 'react-router-dom';
import { 
  Home, Briefcase, 
  Users, BookOpen, Info, Database
} from 'lucide-react';
import { 
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface NavItemsProps {
  scrolled: boolean;
}

const NavItems: React.FC<NavItemsProps> = ({ scrolled }) => {
  return (
    <div className="flex items-center gap-x-6 md:gap-x-8">
      <NavItem 
        to="/" 
        title="Home" 
        icon={<Home className="h-4 w-4" />}
        scrolled={scrolled}
      />
      
      <NavItem 
        to="/diensten" 
        title="Diensten" 
        icon={<Briefcase className="h-4 w-4" />}
        scrolled={scrolled}
      />
      
      <NavItem 
        to="/producten" 
        title="AM Intelligence" 
        icon={<Database className="h-4 w-4" />}
        scrolled={scrolled}
      />
      
      <NavItem 
        to="/jobs" 
        title="Jobs" 
        icon={<Users className="h-4 w-4" />}
        scrolled={scrolled}
      />
      
      <NavItem 
        to="/over-ons" 
        title="Over ons" 
        icon={<Info className="h-4 w-4" />}
        scrolled={scrolled}
      />
      
      <NavItem 
        to="/blog" 
        title="Blog" 
        icon={<BookOpen className="h-4 w-4" />}
        scrolled={scrolled}
      />
    </div>
  );
};

interface NavItemProps {
  to: string;
  title: string;
  icon: React.ReactNode;
  scrolled: boolean;
  badge?: string;
}

const NavItem: React.FC<NavItemProps> = ({ to, title, icon, scrolled, badge }) => {
  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>
          <NavLink 
            to={to} 
            className={({ isActive }) => 
              `px-4 py-3 text-sm font-medium flex items-center ${isActive ? 'text-brand-red' : 'text-gray-700 hover:text-gray-900'}`
            }
            title={title}
          >
            <span className={`${scrolled ? 'inline-block' : 'hidden'} transition-all duration-300`}>
              {icon}
            </span>
            <span className={`${scrolled ? 'hidden' : 'inline-block'} transition-all duration-300`}>{title}</span>
            
            {badge && (
              <span className={`ml-2 text-xs px-1.5 py-0.5 rounded-full bg-brand-red/10 text-brand-red font-medium ${
                scrolled ? 'hidden' : 'inline-flex items-center'
              }`}>
                {badge}
              </span>
            )}
          </NavLink>
        </TooltipTrigger>
        <TooltipContent>
          <p>{title}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default NavItems;
